<script>
import Components from './components'

let filter = f => {
  if (!('condition' in f)) return true
  if (typeof f.condition === 'function') return f.condition()
  return f.condition
}

/** Recursive components builder */
export default {
  name: 'Blocks',
  props: {
    blocks: {
      // object or array of objects with block configs
      type: [Array, Object],
      required: true,
    },
    customComponents: {
      // inject custom components
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    items() {
      if (!this.blocks) return []
      return (this.blocks instanceof Array ? this.blocks : [this.blocks]).filter(block => filter(block))
    },
    Components() {
      return { ...Components, ...this.customComponents }
    },
  },
}
</script>

<template>
  <div class="kpb-blocks">
    <component
      v-for="(item, index) in items"
      :key="index"
      :is="Components[item.component]"
      v-bind="{ ...item.props, data: item.data, variant: item.variant }"
    >
      <template v-for="(child, slot) of item.blocks || {}" v-slot:[slot]>
        <Blocks :key="slot" :blocks="child" :custom-components="customComponents" />
      </template>
    </component>
  </div>
</template>

<style lang="scss">
@import './styles.scss';

.kpb-blocks {
  display: contents;
}
</style>
